
import {
  Box,
  Card,
  CardContent,
  Tab,
  Tabs
} from '@mui/material';

import React, { useState } from 'react';
import { ChargingStationGeneralDetails } from './charging-station-general-details';
import { ChargingStationStatusHeader } from './charging-station-status-header';

import {
  AvailableFirmware,
  ChargingStation,
  ChargingStationStatus as ChargingStationDeviceStatus,
  OcppEvent,
  Transaction
} from 'src/store/model';

import { ChargingStationStatus } from './charging-station-status';
import { ChargingStationTransactions } from './charging-station-transactions';
import { ChargingStationMonitoring } from './charging-station-monitoring';
import { TabPanel } from 'src/components';
import globalStyles from '../../../../global-styles.module.scss';
import { CharginStationSchedule } from './charging-station-schedules';
import { ChargingStationSettings } from './charging-station-settings';
import { ChargingStationInfo } from './charging-station-info';

type Props = {
  chargingStation: ChargingStation | undefined | null;
  chargingStationStatus: ChargingStationDeviceStatus | null | undefined;
  occpEvents: OcppEvent[];
  transactions: Transaction[];
  locationName: string;
  officialFirmwares: AvailableFirmware[];
  unofficialFirmwares: AvailableFirmware[];
  profiles: any[];
  changeFirmware: (update_type: string, location: string, signing_certificate: string, signature: string) => void;
};

export const ChargingStationMetaData = ({
  chargingStation,
  chargingStationStatus,
  occpEvents,
  transactions,
  officialFirmwares,
  unofficialFirmwares,
  profiles,
  changeFirmware,
}: Props) => {

  const handleTabChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const a11yProps = (index: number) => {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`
    };
  };

  const [value, setValue] = useState(0);

  return (
    <Card className={globalStyles.container}>
      <ChargingStationStatusHeader />
      <CardContent style={{ minHeight: 650 }}>
        <Box
          sx={{
            flexGrow: 1,
            bgcolor: 'background.paper',
            display: 'flex'
          }}
        >
          <Tabs
            orientation="vertical"
            style={{ width: '16rem' }}
            value={value}
            onChange={handleTabChange}
          >
            <Tab label="Info" {...a11yProps(0)} />
            <Tab label="Firmware" {...a11yProps(1)} />
            <Tab label="Status" {...a11yProps(2)} />
            <Tab label="Transactions" {...a11yProps(3)} />
            <Tab label="Monitoring" {...a11yProps(4)} />
            <Tab label="Schedules" {...a11yProps(5)} />
            <Tab label="Settings" {...a11yProps(6)} />
          </Tabs>
          <TabPanel value={value} index={0}>
          <ChargingStationInfo
              chargingStation={chargingStation}
            />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ChargingStationGeneralDetails
              chargingStation={chargingStation}
              chargingStationStatus={chargingStationStatus}
              officialFirmwares={officialFirmwares}
              unofficialFirmwares={unofficialFirmwares}
              changeFirmware={changeFirmware}
            />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <ChargingStationStatus events={occpEvents} />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <ChargingStationTransactions transactions={transactions} />
          </TabPanel>
          <TabPanel value={value} index={4}>
            <ChargingStationMonitoring />
          </TabPanel>
          <TabPanel value={value} index={5}>
            <CharginStationSchedule profiles={profiles} isViewer={true}/>
            <CharginStationSchedule profiles={profiles} isViewer={false}/>
          </TabPanel>
          <TabPanel value={value} index={6}>
            <ChargingStationSettings />
          </TabPanel>
        </Box>
      </CardContent>
    </Card>
  );
};
